//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { linkPage, GetLiveStatusInfo } from '~/utils/util';

export default {
  name: 'roadshow-card',
  inject: ['isLink'],
  props: {
    roadshow: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    // 获取如果是路演的状态信息
    roadshowStatus() {
      const liveState = this.roadshow?.liveState;
      return GetLiveStatusInfo(liveState);
    },
    isDeleted() {
      return this.roadshow.liveState === 6;
    },
  },
  methods: {
    linkPage,
  },
};
